import { DatasetDetailView } from "@/components/eval/DatasetDetailView";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/eval-datasets/$id")({
	component: () => {
		const { id } = Route.useParams();
		return <DatasetDetailView datasetId={id} readOnly />;
	},
});
